import React from 'react';
import { Box } from '@mui/material';

import { isLoggedInUserRoot } from '@paragon/login-tools';

import { userToEdit } from '../../selectors/users';
import { useAppSelector } from '../hooks';
import CreateOrganization from './CreateOrganization';
import EditOrganization from './EditOrganization';

export function OrganizationSettings() {
  const user = useAppSelector((state) => userToEdit(state));
  const isRootUser = useAppSelector(isLoggedInUserRoot);

  return user ? (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        flexWrap: { md: 'wrap' },
        justifyContent: 'space-around',
        p: { xs: 1, sm: 3 },
      }}
    >
      <EditOrganization />
      {isRootUser ? <CreateOrganization /> : null}
    </Box>
  ) : null;
}
